import CategoriesTable from './CategoriesTable'

export default CategoriesTable



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/MappingTabs/CategoriesTab/CategoriesTable/index.js